import React, { ReactElement, useState } from 'react';
import useSearchPouzivatelskaSkupina from './hook/useSearchPouzivatelskaSkupina';
import LdapItem from '../../model/LdapItem';
import SearchLdapDataComponent from './component/SearchLdapDataComponent';

interface Props {
  skupina: LdapItem;
  setSkupina: (skupina: LdapItem) => void;
  label: string,
}

const SearchPouzivatelskaSkupina = ({ skupina, setSkupina, label }: Props): ReactElement => {
  const [searchToken, setSearchToken] = useState(null);
  const [data, isFetched] = useSearchPouzivatelskaSkupina(searchToken);

  return (
    <SearchLdapDataComponent
      searchToken={searchToken}
      setSearchToken={setSearchToken}
      ldapItem={skupina}
      setLdapItem={setSkupina}
      label={label}
      data={data}
      isFetched={isFetched}
    />
  );
};

export default SearchPouzivatelskaSkupina;
